import "./style.scss";

import ApartmentOutlined from "@mui/icons-material/ApartmentOutlined";
import KeyboardArrowDown from "@mui/icons-material/KeyboardArrowDown";
import type { SelectChangeEvent } from "@mui/material";
import { Checkbox, FormControl, MenuItem, Select } from "@mui/material";
import type { Dispatch, SetStateAction } from "react";
import { useTranslation } from "react-i18next";
import type { IBeneficiariesCompanies } from "store/types";

type TProps = {
    data: IBeneficiariesCompanies[];
    selectedData: IBeneficiariesCompanies[];
    setSelectedData: Dispatch<SetStateAction<IBeneficiariesCompanies[]>>;
    multipleSeleted?: boolean;
    disabled?: boolean;
};

const PickerCompany = ({ data, selectedData, setSelectedData, multipleSeleted = true, disabled = false }: TProps) => {
    const [t] = useTranslation();

    const handleChange = (ev: SelectChangeEvent<number[]>) => {
        const value = ev.target.value as number | number[];
        if (typeof value === "number") {
            const item = data.filter((elm) => elm.id === value);
            setSelectedData([...item]);
        } else {
            const array = data.filter((elm) => !!value.find((val) => val === elm.id));
            setSelectedData(array);
        }
    };

    return (
        <div className="picker-company">
            <FormControl fullWidth disabled={disabled}>
                <Select
                    multiple={!!multipleSeleted}
                    value={selectedData.map((data) => data.id)}
                    displayEmpty
                    onChange={handleChange}
                    IconComponent={KeyboardArrowDown}
                    MenuProps={{ className: "picker-company-popover" }}
                    sx={{
                        fontFamily: "'Poppins', sans-serif",
                        fontSize: 14,
                        fontWeight: 400,
                        letterSpacing: "0.03em",
                    }}
                    renderValue={(selected) => (
                        <div className="picker-company-render">
                            {selectedData.length === 1 && (
                                <div className="picker-company-render-icon">
                                    {selectedData[0].avatarUrl ? (
                                        <img src={selectedData[0].avatarUrl} alt="avatar" />
                                    ) : (
                                        <ApartmentOutlined />
                                    )}
                                </div>
                            )}
                            <span className="picker-company-render-label">
                                {selected.length === 0
                                    ? t("Titles.NoPublisher")
                                    : selected.length === 1
                                      ? data.find((elm) => elm.id === selected[0])?.name ?? ""
                                      : selected.length === data.length
                                        ? `${t("Titles.AllPublisher")} (${selected.length})`
                                        : `${t("Titles.SomePublisher")} (${selected.length})`}
                            </span>
                        </div>
                    )}
                >
                    {data.map((elm, index) => {
                        return (
                            <MenuItem key={index} value={elm.id} sx={{ justifyContent: "space-between", gap: 1 }}>
                                <div
                                    className="d-flex align-items-center"
                                    style={{ overflow: "hidden", minWidth: 0, flex: 1 }}
                                >
                                    {elm.avatarUrl ? (
                                        <img className="avatar-company" src={elm.avatarUrl} alt="company-avatar" />
                                    ) : (
                                        <ApartmentOutlined className="avatar-company" />
                                    )}
                                    <span
                                        style={{
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            whiteSpace: "nowrap",
                                        }}
                                        title={elm.name}
                                    >
                                        {elm.name}
                                    </span>
                                </div>
                                <Checkbox
                                    value={elm.id}
                                    checked={!!selectedData.find((data) => data.id === elm.id)}
                                    style={{ color: "#275AB0", flexShrink: 0 }}
                                />
                            </MenuItem>
                        );
                    })}
                </Select>
            </FormControl>
        </div>
    );
};

export default PickerCompany;
